import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-salary-forms-7-26',
  templateUrl: './salary-forms-7-26.component.html',
  styleUrl: './salary-forms-7-26.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SalaryForms726Component {

}
